
export function getListEconMember(axiosPrivate){
  return axiosPrivate.get(`/fta-impact/economies-member`)
}

export function runSimulation(axiosPrivate, params){
  return axiosPrivate.post(`/fta-impact/simulation`,{
    rep: params.rep,
    par: params.par,
    impact_for: params.econ,
    year: params.year,
    elas_supply: params.supplyElas,
    elas_substitution: params.subElas,
    elas_type: params.elasType,
  })
}